export default "__VITE_ASSET__BHohZLFe__"